/** Single source of truth for the facts that appear in more than one place. */
export const SITE = {
  name: 'AppNexa',
  domain: 'appnexa.vercel.app',
  url: 'https://appnexa.vercel.app',
  playDeveloperId: '5785597722023993210',
  since: 2019,
  legalUpdated: '18 October 2026',
};

/**
 * The studio address is never written into the markup as plain text — it is
 * assembled at runtime so scrapers crawling the HTML come away with nothing.
 * Use <MailLink /> rather than printing this.
 */
const USER = ['cse', 'deepakyadav'];
const HOST = ['gmail', 'com'];

export const studioAddress = () => `${USER.join('.')}@${HOST.join('.')}`;

export const mailto = (subject, body = '') =>
  `mailto:${studioAddress()}?subject=${encodeURIComponent(subject)}${
    body ? `&body=${encodeURIComponent(body)}` : ''
  }`;
